import { SetStateAction } from 'react';
import {
  Card, CardContent, Box,
  InputLabel,
} from '@mui/material';
import {
  Form, SaveButton, useNotify,
} from 'react-admin';
import Grid2 from '@mui/material/Unstable_Grid2';
import { User } from '@x-guard/xgac-types/xgac';
import { useTranslate } from 'ra-core';
import { xgacDataProvider } from '../../../dataProviders/xgacDataProvider';
import { PhoneNumberInput } from '../../../components/inputs/PhoneNumberInput';

const Grid = Grid2;

export const PhoneInputCard = (props: { user: User; userSetter: SetStateAction<any> }) => {

  const notify = useNotify();
  const translate = useTranslate();
  const savePhoneNumber = async (data: any) => {

    if (props.user._id && data.properties.phoneNumber) {

      try {

        const updateResult = await xgacDataProvider.update('users', {
          id: props.user._id,
          data: {
            properties: { ...props.user.properties, phoneNumber: data.properties.phoneNumber, smsNumber: data.properties.phoneNumber },
          },
          previousData: {},
        });
        props.userSetter(updateResult.data);

      } catch (e) {

        console.log(e);
        notify('general.text.incorrect_phonenumber', { type: 'warning' });

      }

    }

  };

  return (
    <>
      <Grid xs={12} md={7}>
        <Card style={{ height: '100%' }} color={'secondary'}>
          <CardContent>
            <h4>{translate('homepage.text.continue_setting_up')}</h4>
            <p>{translate('homepage.text.continue_setting_up_subtext')}
            </p>
            <Form onSubmit={savePhoneNumber}>
              <InputLabel className="input-label">
                {translate('resources.assets.fields.phoneNumber')}
              </InputLabel>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  flexWrap: 'wrap',
                }}
              >
                <Box
                  sx={{
                    width: 250,
                    flexShrink: 0,
                    '& .input-label': { display: 'none' },
                    '& .MuiFormControl-root': { margin: 0 },
                    '& .MuiOutlinedInput-root': {
                      height: 41,
                    },
                  }}
                >
                  <PhoneNumberInput
                    colorVariant="gray"
                    source="properties.phoneNumber"
                    fullWidth
                    helperText={false}
                    size="small"
                  />
                </Box>
                <SaveButton
                  label="general.text.proceed"
                  icon={<></>}
                  color="secondary"
                  className="inlineSticky"
                  alwaysEnable
                  sx={{
                    height: 41,
                    minWidth: 'auto',
                    px: 2,
                  }}
                />
              </Box>
            </Form>
          </CardContent>
        </Card>
      </Grid>
    </>
  );

};
